/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Linux_ReqInputs */

const en_fc_dl_linux_req = /** @type {(inputs: Fc_Dl_Linux_ReqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux · x86_64, ARM64 (aarch64) and RISC-V (riscv64)`)
};

/**
* | output |
* | --- |
* | "Linux · x86_64, ARM64 (aarch64) and RISC-V (riscv64)" |
*
* @param {Fc_Dl_Linux_ReqInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_linux_req = /** @type {((inputs?: Fc_Dl_Linux_ReqInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Linux_ReqInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_linux_req(inputs)
});
export { fc_dl_linux_req as "fc.dl.linux.req" }